import React from 'react';
import './style.scss';
import { identity } from "../../../../utils/getIdentity";

const InputFeeForFilterTransactions = ({ title, amount }) => {
  return (
    <div className="inputFeeForFilter">
      <div className={`inputFeeForFilter__title inputFeeForFilter__title-${identity}`}>{title}</div>
      <div className={`inputFeeForFilter__block inputFeeForFilter__block-${identity}`}>
        <span className="inputFeeForFilter__amount">{amount || 0}</span>
        <span className="inputFeeForFilter__currency">USD</span>
      </div>
    </div>
  );
};

export default InputFeeForFilterTransactions;
